export enum ChannelStatus {
  NONE = 'none',
  ACTIVE = 'active',
  ERROR = 'error',
  DISABLED = 'disabled',
  PRO_ERROR = 'pro_error',
  BANNED = 'banned',
}
